import Flickity from "flickity";
import { gsap } from "../global/gsap";

const initSignpostGallery = (element) => {
    const prevBtn = element.parentNode.querySelector(".js-prev");
    const nextBtn = element.parentNode.querySelector(".js-next");

    const tickerSpeed = 0.5;
    let flickity = null;
    let isPaused = false;
    let animFrameId = null; // Track animation frame to avoid multiple concurrent loops

    const update = () => {
        if (isPaused) return;
        if (flickity.slides) {
            flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
            flickity.selectedIndex = flickity.dragEndRestingSelect();
            flickity.updateSelectedSlide();
            flickity.settle(flickity.x);
        }
        animFrameId = window.requestAnimationFrame(update);
    };

    const pause = () => {
        isPaused = true;
        if (animFrameId) {
            window.cancelAnimationFrame(animFrameId);
        }
    };

    const play = () => {
        if (isPaused) {
            isPaused = false;
            // Cancel existing frame to prevent speed-stacking
            if (animFrameId) window.cancelAnimationFrame(animFrameId);
            animFrameId = window.requestAnimationFrame(update);
        }
    };

    const flickityOptions = {
        cellAlign: "center",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: true,
        cellSelector: ".js-gallery-item",
        selectedAttraction: 0.015,
        friction: 0.25,
        freeScroll: true,
    };

    flickity = new Flickity(element, flickityOptions);
    flickity.x = 0;

    // Handle drag events
    flickity.on("dragStart", pause);
    flickity.on("dragEnd", play);

    element.addEventListener("mouseleave", play, false);
    element.addEventListener("focusout", play, false);

    // --- Custom Prev / Next Button Logic ---
    const navigate = (direction) => {
        pause(); // Freeze continuous ticker tick

        // Move to slide
        if (direction === "next") {
            flickity.next(true); // true enables wrap-around loop navigation
        } else {
            flickity.previous(true);
        }
    };

    if (prevBtn) prevBtn.addEventListener("click", () => navigate("prev"));
    if (nextBtn) nextBtn.addEventListener("click", () => navigate("next"));

    // Resume continuous ticker once slide animation settles
    flickity.on("settle", () => {
        // Only resume if user isn't currently hovering or dragging
        if (!element.matches(":hover")) {
            play();
        }
    });

    update();

    // const cards = elment.querySelectorAll('.js-gallery-item');

    // Set initial cards scale
    // gsap.set(cards, {
    //     scale: 0.6
    // });

    // const slideTl = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: element,
    //         start: () => 'top bottom',
    //         end: () => 'bottom top',
    //         scrub: true,
    //         invalidateOnRefresh: true
    //     }
    // });

    // // Slide elements scrollable width
    // slideTl.to(element, {
    //     x: () => `${-(element.scrollWidth - document.documentElement.clientWidth)}px`,
    //     ease: 'none'
    // });

    // // Loop over cards and update scale as slideTl moves
    // cards.forEach((card) => {
    //     const cardTl = gsap.timeline({
    //         scrollTrigger: {
    //             trigger: card,
    //             containerAnimation: slideTl,
    //             start: 'left right',
    //             end: 'right left',
    //             scrub: true,
    //             invalidateOnRefresh: true
    //         }
    //     });

    //     cardTl.to(card, {
    //         keyframes: [
    //             { scale: 1 },
    //             { scale: 0.6 }
    //         ],
    //         ease: 'none'
    //     });
    // });
};

export { initSignpostGallery as default };
